<template>
  <div class="contact-section">
    <b-card class="shadow" no-body>
      <b-card-body>
        <b-card-title class="dark-variant">Contact</b-card-title>

        <!-- Corporate office -->
        <div class="ct-block">
          <h6 class="ct-heading">
            <span class="material-icons">business</span>
            <span>Corporate Office &mdash; {{ company.office }}</span>
          </h6>
          <div class="contact-info">
            <b-card-text>
              <p>Company Name</p>
              <p>Address</p>
              <p>Phone</p>
              <p>Email</p>
              <p>WebSite</p>
            </b-card-text>
            <b-card-text class="dark-variant">
              <p class="company-name">{{ company.name }}</p>
              <p class="address">{{ company.address }}</p>
              <p class="phone">
                <a :href="company.phoneLink">{{ company.phone }}</a>
              </p>
              <p class="email">
                <a :href="'mailto:' + company.email">{{ company.email }}</a>
              </p>
              <p class="website">
                <a :href="company.websiteUrl" target="_blank" rel="noopener noreferrer">{{ company.website }}</a>
              </p>
            </b-card-text>
          </div>
        </div>

        <!-- Support -->
        <div class="ct-block">
          <h6 class="ct-heading">
            <span class="material-icons">support_agent</span>
            <span>Customer Support</span>
          </h6>
          <ul class="ct-support">
            <li v-for="(item, index) in support" :key="'sup-' + index">
              <span class="ct-support-label">{{ item.label }}</span>
              <a :href="'mailto:' + item.email">{{ item.email }}</a>
            </li>
          </ul>
        </div>

        <!-- Branches -->
        <div class="ct-block">
          <h6 class="ct-heading">
            <span class="material-icons">public</span>
            <span>Branches &amp; Network</span>
          </h6>
          <div class="ct-branches">
            <div class="ct-branch" v-for="(branch, index) in branches" :key="'br-' + index">
              <p class="ct-branch-name">{{ branch.name }}</p>
              <p class="ct-branch-line">{{ branch.address }}</p>
              <p class="ct-branch-line">
                <span class="material-icons">call</span>
                <a :href="branch.phoneLink">{{ branch.phone }}</a>
              </p>
              <p class="ct-branch-line">
                <span class="material-icons">mail_outline</span>
                <a :href="'mailto:' + branch.email">{{ branch.email }}</a>
              </p>
            </div>
          </div>
        </div>

        <div class="ct-foot">
          <router-link :to="{ name: 'FeedBack' }">Send us feedback</router-link>
          <span class="ct-sep">|</span>
          <router-link :to="{ name: 'FAQ' }">Read the FAQs</router-link>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
function telLink(value) {
  return "tel:" + String(value || "").replace(/[^+0-9]/g, "");
}

export default {
  name: "ContactDetail",
  data() {
    return {
      company: {
        name: "Amej Pay Pte. Ltd.",
        office: "Asia Pacific (APAC)",
        address: "S&J Building, 104, Rachaparop Soi 1, Phayathai, Bangkok 10400, Thailand",
        phone: "+66 626513995",
        phoneLink: telLink("+66626513995"),
        email: "apac@amejpay.com",
        website: "AMEJPAY.COM",
        websiteUrl: "https://www.amejpay.com"
      },
      support: [
        { label: "General support", email: "support@amejpay.com" },
        { label: "Product feedback", email: "amej.product@gmail.com" }
      ],
      branches: [
        {
          name: "USA Office",
          address: "24 Lark Lane, Croton On Hudson, New York 10520",
          phone: "+1 9148062214",
          phoneLink: telLink("+1 9148062214"),
          email: "usa@amejpay.com"
        },
        {
          name: "Thailand Office",
          address: "S&J Building, 104, Rachaparop Soi 1, Phayathai, Bangkok 10400, Thailand",
          phone: "+66 626513995",
          phoneLink: telLink("+66626513995"),
          email: "thailand@amejpay.com"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/style.scss";

.contact-section {
  .ct-block {
    margin-bottom: 22px;
  }

  .ct-block:last-of-type {
    margin-bottom: 8px;
  }

  .ct-heading {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #8a94a6;
    margin-bottom: 10px;

    .material-icons {
      font-size: 16px;
      margin-right: 6px;
    }
  }

  .contact-info {
    p {
      margin-bottom: 8px;
      line-height: 1.35;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  .ct-support {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      padding: 6px 0;
      border-bottom: 1px solid #f0f2f5;
      font-size: 14px;
    }

    li:last-child {
      border-bottom: 0;
    }

    .ct-support-label {
      color: #8a94a6;
      margin-right: 12px;
      white-space: nowrap;
    }

    a {
      font-weight: 500;
      word-break: break-all;
      text-align: right;
    }
  }

  .ct-branches {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 12px;
  }

  .ct-branch {
    background: #f7f9fc;
    border: 1px solid #eceff4;
    border-radius: 8px;
    padding: 12px 14px;

    .ct-branch-name {
      font-weight: 600;
      margin-bottom: 6px;
    }

    .ct-branch-line {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #6b7280;
      margin-bottom: 4px;
      line-height: 1.35;

      .material-icons {
        font-size: 14px;
        margin-right: 6px;
        flex: 0 0 auto;
      }

      a {
        color: inherit;
      }

      a:hover {
        text-decoration: underline;
      }
    }

    .ct-branch-line:last-child {
      margin-bottom: 0;
    }
  }

  .ct-foot {
    padding-top: 12px;
    border-top: 1px solid #f0f2f5;
    font-size: 13px;

    .ct-sep {
      color: #cbd2dc;
      margin: 0 8px;
    }
  }
}

@media (min-width: 1200px) {
  .contact-section .ct-branches {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
